const loadImage = (el, src) => {
    if (!src) return
    el.src = src
}

const observeImage = (el, src) => {
    if (typeof IntersectionObserver === 'undefined') {
        loadImage(el, src)
        return
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting || entry.intersectionRatio > 0) {
                loadImage(el, src)
                observer.unobserve(el)
                if (el._lazyObserver) {
                    delete el._lazyObserver
                }
            }
        })
    }, {
        rootMargin: '100px',
        threshold: 0.1
    })

    observer.observe(el)
    el._lazyObserver = observer
}

const cleanupObserver = (el) => {
    if (el._lazyObserver) {
        el._lazyObserver.disconnect()
        delete el._lazyObserver
    }
}

const lazyDirective = {
    mounted(el, binding) {
        if (el instanceof HTMLImageElement) {
            if ('loading' in HTMLImageElement.prototype) {
                el.loading = 'lazy'
                loadImage(el, binding.value)
            } else {
                observeImage(el, binding.value)
            }
        } else {
            loadImage(el, binding.value)
        }
    },
    updated(el, binding) {
        if (binding.value === binding.oldValue) return
        cleanupObserver(el)
        if (el instanceof HTMLImageElement && 'loading' in HTMLImageElement.prototype) {
            el.loading = 'lazy'
            loadImage(el, binding.value)
        } else {
            observeImage(el, binding.value)
        }
    },
    unmounted(el) {
        cleanupObserver(el)
    }
}

export default lazyDirective
